import { InlineButton } from '@liveauctioneers/hammer-ui-core/inlineButton';
import { H1 } from '@liveauctioneers/hammer-ui-core/text';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { CategoryNamesAndIds } from '../../constants/constant';

type Props = {
    isMobile: boolean;
    scrollToCategory: (categoryId: number) => void;
};

export const Sidebar = ({ isMobile, scrollToCategory }: Props) => {
    const formatMessage = useAppFormatMessage();
    const CATEGORIES = Object.keys(CategoryNamesAndIds);

    if (isMobile) {
        return null;
    }

    return (
        <div className="sticky top-0 flex w-fit flex-col self-start">
            <H1
                className="bg-white sticky top-0 my-lg w-max"
                data-testid="discoverPageTitle"
            >
                {formatMessage(['discoverPage', 'exploreCategories'])}
            </H1>
            {CATEGORIES.map((category, index) => (
                <InlineButton
                    className="mb-[22px] w-max"
                    key={index}
                    onClick={() => scrollToCategory(index)}
                    style="neutral"
                >
                    {formatMessage(['discoverPage', 'sidebar', 'category'], { values: { category } })}
                </InlineButton>
            ))}
            <InlineButton
                className="mb-[22px] w-max"
                onClick={() => {
                    scrollToCategory(CATEGORIES.length);
                }}
                style="neutral"
            >
                {formatMessage(['discoverPage', 'sidebar', 'allOtherCategories'])}
            </InlineButton>
        </div>
    );
};
